module.exports = __webpack_public_path__ + "static/media/profile.79ba2002.jpg";